import { render, staticRenderFns } from "./FormulaTextView.vue?vue&type=template&id=ecd5f4ca&scoped=true"
import script from "./FormulaTextView.vue?vue&type=script&lang=js"
export * from "./FormulaTextView.vue?vue&type=script&lang=js"
import style0 from "./FormulaTextView.vue?vue&type=style&index=0&id=ecd5f4ca&prod&scoped=true&lang=css"
import style1 from "./FormulaTextView.vue?vue&type=style&index=1&id=ecd5f4ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd5f4ca",
  null
  
)

export default component.exports